export const ListQueryKey = 'activityRecommendRecords';
export const DetailQueryKey = 'activityRecommendRecord';
export const Urls = {
  selectUrl: '/activityRecommendRecord/list',
  updateUrl: '/activityRecommendRecord/update',
  deleteUrl: '/activityRecommendRecord/delete',
  createUrl: '/activityRecommendRecord/create',
  detailUrl: '/activityRecommendRecord/info'
};